export enum BottomToolbarType {
  EMPTY = '',
  PAN = 'pan',
  POINTER = 'pointer',
  PEN = 'pen',
  ERASER = 'erase',
  TEXT = 'text',
  SHAPES = 'shapes',
  STICKY = 'sticky-note',
  FORMULA = 'formula',
  UPLOAD = 'upload',
  UNDO_REDO = 'undo-redo',
  SCREENSHARE = 'screenshare',
  ZOOM = 'zoom',
  TOOLBOX = 'toolbox',
  CHAT = 'chat',
  START_AI = 'start-ai',
  WEB_VIEWER = 'web-viewer',
  BOARDS = 'boards',
  GALLERY_MODE = 'gallery-mode',
  RAISE_HAND = 'raise-hand',
  SCREEN_SHARE = 'screen-share',
  OVERFLOW = 'overflow',
  OVERFLOW_RIGHT = 'overflow-right',
  CLEAR_BOARD = 'clear-board',
  VIDEO_TILE_MENU = 'video-tile-menu',
  MINIMIZE_ANNOTATIONS = 'minimize-annotations',
  CONTENT_NAV = 'content-nav',
}

export enum BottomToolbarDisplayMode {
  DESKTOP = 'tb-desktop',
  DESKTOP_OVERFLOWED = 'tb-desktop-overflowed',
  TABLET = 'tb-tablet',
  MOBILE = 'tb-mobile',
}

export const OVERFLOWABLE_TOOLS = [
  BottomToolbarType.TEXT,
  BottomToolbarType.STICKY,
  BottomToolbarType.SHAPES,
  BottomToolbarType.UPLOAD,
  BottomToolbarType.TOOLBOX,
  BottomToolbarType.ZOOM,
];
